// Entry point for the build script in your package.json

// Libraries
import './lib/rails';
import './lib/jquery';
import './lib/bootstrap';
import './lib/toastr';

// App modules
import './cable';
import './header';
import './carousel';
import './clipboard';
import './application/init_tooltip';

// Forms
import './address_autocomplete';
import './hide_show_password';
import './input_files';
import './auto_submit_form';
import './select2_init';

// Users
import './users/profile';
import './hide_show_ubo_beneficiary';
import './users/kyc_documents';

// Subscriptions & projects
import './subscribe_modal';
import './carousel_pending_subscriptions';
import './sponsorship_share';
import './projects/show/modal_tab_selector';

// STIMULUS
import './controllers';

if (!Rails.started) {
  Rails.start();
}

toastr.options.timeOut = 3000;
